import { render } from "./PlanShipmentSettingsItemCreateEditDialog.vue?vue&type=template&id=137ec215&scoped=true&ts=true"
import script from "./PlanShipmentSettingsItemCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./PlanShipmentSettingsItemCreateEditDialog.vue?vue&type=script&lang=ts"

import "./PlanShipmentSettingsItemCreateEditDialog.vue?vue&type=style&index=0&id=137ec215&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137ec215"]])

export default __exports__